import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAssessedBy,
  setAttempts,
  setDateTime,
  setDevicesUsed,
  setOption,
  setSuccessfulAttempt,
} from '../../procedures/immobilization/store/immobilization.actions'
import { setAddImmobilizationToTimeline } from '../store/quickActions.actions'
import { getImmobilizationOptionsSelector, getVitalOptionsSelector } from '../../options/selectors'
import { IImmobilizationOptionsState, IVitalOptionsState } from '../../options/store/options.types'
import { IOption } from '../../../common/common.types'

export function* setImmobilizationQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate, procedureAction, option } = props
  const { devicesUsedOptions }: IImmobilizationOptionsState = yield select(getImmobilizationOptionsSelector)
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  const devicesUsedOption = devicesUsedOptions.filter((option: IOption) => option.id === procedureAction)

  yield put(setDateTime(savedTimeString, currentDate))
  yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
  yield put(setSuccessfulAttempt(true))
  yield put(setAttempts('1'))
  yield put(setAddImmobilizationToTimeline(true))
  yield put(setOption(option || null))
  yield put(setDevicesUsed(devicesUsedOption ? devicesUsedOption : []))
}

export function* setImmobilizationQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_IMMOBILIZATION_BUTTON_TYPE], setImmobilizationQuickAction)
}
